import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Form, FormLayout, TextField, Button, Select, ChoiceList, Checkbox } from '@shopify/polaris';

import { BasicTextField } from '@presentational';
import { SellerForm } from '@presentational';
import FormPageActions from '@container/FormPageActions';

import { tAttribute } from '@utils';

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  isSeller: PropTypes.bool,
  deleteURL: PropTypes.string,
};

// TODO make this a prop!!!!
const options_roles = [
  {label: I18n.t("enum.role.general"), value: 'general'},
  {label: I18n.t("enum.role.admin"), value: 'admin'},
  {label: I18n.t("enum.role.owner"), value: 'owner'},
  {label: I18n.t("enum.role.resource_admin"), value: 'resource_admin'},
];

const UserForm = ({ users, location, handleChangeSeller, handleChange, handleSubmit, toggleValue, toggleSeller, isSeller, values, errors, ...props}) => {
  let sharedFieldProps = {
    handleChange,
    values,
    errors
  }

  return(
    <Form onSubmit={handleSubmit}>
      <FormLayout>
        <hr />
        <BasicTextField
          name="first_name"
          label={ tAttribute("user", "first_name") }
          {...sharedFieldProps}
        />

        <BasicTextField
          name="last_name"
          label={ tAttribute("user", "last_name") }
          {...sharedFieldProps}
        />

        {/* Check for general errors for user email OR errors from seller to user email */}
        <BasicTextField
          name="email"
          label={tAttribute("user", "email")}
          type="email"
          {...sharedFieldProps}
          error={ errors && ( errors.email || errors["seller.user_email"] ) }
        />

        <BasicTextField
          name="password"
          label={tAttribute("user", "password")}
          type="password"
          {...sharedFieldProps}
        />

        <Select
          id="role"
          name="role"
          label="Role"
          options={options_roles}
          value={ values.role }
          onChange={ handleChange }
        />

        <Checkbox
          checked={ isSeller }
          label="Is seller?"
          onChange={ toggleSeller }
        />

        { isSeller &&
          <SellerForm
            users={ [] }
            locations={ location }
            handleChange={ handleChangeSeller }
            handleSubmit={ handleSubmit }
            values={ values.seller }
            errors={ errors }
            isNested={ true }
            deliveryTeamOptions={ props.deliveryTeamOptions }
          />
        }

      <FormPageActions
        onPrimaryAction={ handleSubmit }
        loading={ props.loading }
        deleteURL={ props.deleteURL }
      />
      </FormLayout>
    </Form>
  )
}



UserForm.propTypes = propTypes;


export default UserForm;
